/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseCVOpenIcon64Regular = forwardRef('ArrowCollapseCVOpenIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M37.303 5.182a7.5 7.5 0 0 0-10.606 0L10.439 21.439a1.5 1.5 0 0 0 2.122 2.122L28.818 7.303a4.5 4.5 0 0 1 6.364 0L51.44 23.561a1.5 1.5 0 1 0 2.12-2.122L37.304 5.182Z" }),
        React.createElement("path", { d: "M37.303 58.818a7.5 7.5 0 0 1-10.606 0L10.439 42.561a1.5 1.5 0 0 1 2.122-2.121l16.257 16.257a4.5 4.5 0 0 0 6.364 0L51.44 40.44a1.5 1.5 0 1 1 2.12 2.121L37.304 58.818Z" })));
});
